import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'gpTestId',
  pure: true
})
export class GpTestIdPipe implements PipeTransform {

  transform(value: string, componentName: string, uniqueValue?: string | number): string {
    return uniqueValue ? [componentName, uniqueValue, value].join('-') : [componentName, value].join('-');
  }

}
